import { bindActionCreators } from "redux"
import { SET_CURRENT_ORG } from "types/actions/organization"

const currentOrgInitialState = {
  currentOrg: {},
  reset: false
}

export default (state = currentOrgInitialState, action) => {
  switch (action.type) {
    case SET_CURRENT_ORG:
      return {
        ...state,
        currentOrg: { ...state.currentOrg, ...action.data },
        reset: action.reset
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/organization.js